import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { formatarData, formatarValor } from "../components/formatarValores";
import ReactGA from "react-ga4";
import { useLanguage } from "../context/LanguageContext";
import { isImpersonating } from "../utils/impersonation";

function ListaCompras() {
  const { t } = useLanguage();
  const isSimulating = isImpersonating();
  const [compra, setCompra] = useState([]);
  const [noCompras, setNoCompras] = useState(false); // Estado para lidar com a ausência de compras
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("adminImpersonation")) return;
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Minhas compras",
    });
  }, []);

  let idAtleta = localStorage.getItem("user");
  idAtleta = JSON.parse(idAtleta);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/compras/cliente/${
            idAtleta.id
          }`
        );

        if (response.status === 201 || response.data.length === 0) {
          setNoCompras(true);
        } else {
          const sortedData = response.data.sort(
            (a, b) => new Date(b.dataCompra) - new Date(a.dataCompra) // Ordenar da data mais nova para a mais velha
          );
          setCompra(sortedData);
        }
      } catch (error) {
        setError(true);
        console.error("Erro ao buscar compra:", error);
      }
    };

    fetchData();
  }, []);

  const detalheCompra = (id) => {
    localStorage.setItem("idCompra", id);
    navigate("/ar/pagamentos/novo");
  };

  return (
    <div className={`py-8 max-w-4xl mx-auto ${isSimulating ? "mt-24 sm:mt-28" : "mt-16"} transition-all`}>
      <div className="mx-auto">
        <h1 className="text-2xl font-semibold text-center mb-6">
          {t("orders.title")}
        </h1>
        {error ? (
          <p className="text-center text-red-500">{t("orders.errorLoading")}</p>
        ) : noCompras ? (
          <p className="text-center">{t("orders.noOrders")}</p>
        ) : (
          <table className="table ml-0">
            <thead>
              <tr>
                <th className="text-center">{t("orders.dateTime")}</th>
                <th className="text-center px-1 min-w-[20px] max-w-[20px]">
                  {t("orders.quantity")}
                </th>
                <th className="text-center">{t("orders.value")}</th>
                <th className="text-center">{t("orders.status")}</th>
                <th className="text-center">{t("orders.details")}</th>
              </tr>
            </thead>
            <tbody>
              {compra.map((compra, index) => (
                <tr key={compra._id} className="bg-base-100 hover:bg-base-300">
                  <td className="py-3 px-2 text-center">
                    {formatarData(compra.dataCompra)}
                  </td>
                  <td className="py-3 px-0 text-center min-w-[20px] max-w-[20px]">
                    {compra.quantity}
                  </td>
                  <td className="py-3 px-2 text-center">
                    R$ {formatarValor(compra.totalPrice)}
                  </td>
                  <td
                    className={`py-3 px-2 text-center ${
                      compra.status === "Pago"
                        ? "text-green-600"
                        : "text-orange-500"
                    }`}
                  >
                    {compra.status === "Pago"
                      ? t("payment.statusPaid")
                      : compra.status === "Pendente"
                      ? t("payment.statusPending")
                      : compra.status === "Pagamento em análise"
                      ? t("payment.statusInReview")
                      : compra.status}
                  </td>
                  <td className="py-3 px-2">
                    <div className="flex justify-center gap-x-1">
                      <button
                        onClick={() => detalheCompra(compra._id)}
                        className={`${
                          compra.status === "Pago"
                            ? "bg-green-600  hover:bg-green-900"
                            : "bg-orange-500  hover:bg-orange-900"
                        } rounded-md text-white py-2 px-2 font-normal text-sm`}
                      >
                        {t("orders.details")}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default ListaCompras;
